interface AccessGroupIdArgs {
  accessGroupId: number;
}

export const accessGroupPaths = {
  edit: ({ accessGroupId }: AccessGroupIdArgs) =>
    `/settings/access_groups/${accessGroupId}`,
} as const;
